import React from 'react';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Button, Layout, Result } from 'antd';
import { t } from '../../../utils/i18n';

import Shore404Icon from '../../../assets/images/svg/shore-404.svg';

const StyledContent = styled(Layout.Content)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.antd.colorWhite};
`;

const StyledShore404Icon = styled(Shore404Icon)`
  width: 100%;
`;

export function NotFoundPage() {
  const navigate = useNavigate();

  const handleOnBackToCalendarClick = () => {
    navigate(`/calendar`);
  };

  return (
    <StyledContent>
      <Result
        icon={<StyledShore404Icon />}
        title={t('page-404.title')}
        subTitle={t('page-404.description')}
        extra={
          <Button type="primary" onClick={handleOnBackToCalendarClick}>
            {t('page-404.button.back-to-calendar')}
          </Button>
        }
      />
    </StyledContent>
  );
}
